// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1sZtQ","label":"SetPasswdForm_label__y0ZFe"};